import { useAppDispatch, useAppSelector } from '@/app/hooks';
import { UserOutlined } from '@ant-design/icons';
import { setFavorites } from '@/features/favorite/favoriteSlice';
import { useAuthStore } from '@/zustand/useAuthGoogle';
import { signOut } from 'firebase/auth';
import { auth } from '@/services/firebase';
import { OfflineUser } from '@/components/atoms/OfflineUser';
import { AudioFooter } from '@/components/molecules/AudioFooter';
import { Footer } from '@/components/molecules/Footer';
import {
  selectSingleTrack,
  setAutoPlay
} from '@/features/singleTrack/singleTrackSlice';
import { SelectAuth } from '@/features/spotifyAuth/authSlice';
import { logout } from '@/utils/logout';
import { useEffect } from 'react';
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import { routes } from './routes';
import { Picture } from '@deyvis17gy/atom-img';
import loader from '../assets/img/Spinning.gif';
import '@deyvis17gy/atom-img/dist/index.css';

export const RouterPrivate = () => {
  const { track, trackId } = useAppSelector(selectSingleTrack);
  const { user, isGuest } = useAppSelector(SelectAuth);
  const { setUser: resetUser } = useAuthStore((state) => state);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const logoutUser = () => {
    if (user) {
      dispatch(setFavorites([]));
    }
    logout(dispatch);
    signOut(auth);
    resetUser(null);
    navigate('/');
  };

  useEffect(() => {
    dispatch(setAutoPlay(false));
  }, [dispatch]);

  return (
    <div className='bg-router-private'>
      <OfflineUser />
      <Picture
        onClick={() => logoutUser()}
        classPicture='router-header'
        url={user.images && user.images[0]?.url}
        loaderUrl={loader}
        isBorderRadius={true}
        alt={user.display_name}>
        <UserOutlined onClick={() => logoutUser()} />
      </Picture>
      <Routes>
        {routes.private.map((route) => (
          <Route
            key={route.path}
            path={route.path}
            element={<route.component />}
          />
        ))}
        <Route
          path='/*'
          element={<Navigate to={routes.private[0].to} replace />}
        />
      </Routes>
      {trackId?.track?.id ? (
        <AudioFooter track={trackId} />
      ) : (
        track?.track && <AudioFooter track={track} />
      )}
      <Footer isGuest={isGuest} />
    </div>
  );
};
